/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Role_Brand_ContactInputs */

const en_contact_role_brand_contact = /** @type {(inputs: Contact_Role_Brand_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand contact`)
};

/**
* | output |
* | --- |
* | "Brand contact" |
*
* @param {Contact_Role_Brand_ContactInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_role_brand_contact = /** @type {((inputs?: Contact_Role_Brand_ContactInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Role_Brand_ContactInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_role_brand_contact(inputs)
});